module.exports = __webpack_public_path__ + "img/contact.5fdcd77f.jpg";